export default "__VITE_ASSET__2b71ee96__"